import { io } from "socket.io-client";

const SERVER_URL = "https://globisun-app.onrender.com"; // Use your deployed URL in production

let socket = null;

export const connectSocket = (userId) => {
  // Prevent creating multiple socket connections
  if (socket) {
    console.log("⚠️ Socket already connected");
    return socket;
  }

  if (!userId) {
    console.error("❌ userId is missing, cannot join room");
  }

  socket = io(SERVER_URL, {
    withCredentials: true,
    transports: ["websocket"], // fallback support
    reconnectionAttempts: 10,   // try reconnecting 10 times if disconnected
    timeout: 20000,             // 20 seconds timeout
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id, "UserID:", userId);
    if (userId) {
      socket.emit("join", userId); // join room based on user ID
      console.log(`👤 User ${userId} joined room`);
    }
  });

  socket.on("disconnect", (reason) => {
    console.log("🔌 Socket disconnected:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
  });

  return socket;
};

export const getSocket = () => socket;
